import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { mainAppConfigProviders } from '../../../../src/app/app.config';
import { projectConfig } from './config';
import { projectEncryptData } from './project';

import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { getFirebaseConfig } from '../../../../src/app/utils/fcm-provider';
import { initializeApp as initializeAppFirebase, provideFirebaseApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

declare global {
  var selfEnv: string;
  var selfPc: string;
}
window['selfEnv'] = projectEncryptData(environment);
window['selfPc'] = projectEncryptData(projectConfig);


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    ...mainAppConfigProviders,
    // * Firebase - Start
    importProvidersFrom(
      AngularFireModule.initializeApp(getFirebaseConfig() ?? {})
    ),
    provideFirebaseApp(() => initializeAppFirebase(getFirebaseConfig() ?? {})),
    provideMessaging(() => getMessaging()),
    // * Firebase - End
  ]
};
